module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Thin-77802bee08341c385a0e6d7ed5f9dcfa.ttf";